module.exports = __webpack_public_path__ + "img/code1.1e9fea66.png";